import nav_logo from '../assets/images/navbar_logo.svg';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useState, useEffect } from 'react';

const Logo = () => {
  const [redirectPath, setRedirectPath] = useState("/select-pump");
  const { user } = useSelector((store) => store.user);

  useEffect(() => {
    if (user?.role) {
      if (user.role === "admin") {
        setRedirectPath("/customer-list");
      } else if (user.role === "sales") {
        setRedirectPath("/sales-order-list");
      }
    }
  }, [user]);

  return (
    <NavLink to={redirectPath}>
      <img src={nav_logo} alt="navbar logo" className="nav_logo" />
    </NavLink>
  );
};
export default Logo;
